import { Indicator } from 'utils/models';
import { Symptom } from 'models/generic';
import { HeartRhythmMeasurement } from 'models/heartRhythm/measurement';
import { defaultMeasurementIndicators } from 'utils/measurement';

type SymptomIndicatorCount = Partial<Record<Indicator, number>>;

interface SymptomsResultProps {
  [symptom: string]: SymptomIndicatorCount;
}

export const getSymptomRhythmData = (measurements?: HeartRhythmMeasurement[]) => {
  // Anxiety is a BP only symptom, and should not appear on Symptom Rhythm
  const allSymptoms = Object.values(Symptom).filter((value) => value !== Symptom.Anxiety);
  const result: SymptomsResultProps = {};

  const doesIndicatorExist = (indicator?: Indicator) => {
    if (!indicator) {
      return false;
    }
    return Object.values(defaultMeasurementIndicators).includes(indicator);
  };

  for (const symptom of allSymptoms) {
    if (!result[symptom]) {
      result[symptom] = {};

      defaultMeasurementIndicators.forEach((indicator) => {
        if (!result[symptom][indicator]) {
          result[symptom][indicator] = 0;
        }
      });
    }
  }

  if (measurements) {
    for (const measurement of measurements) {
      if (measurement?.data?.context?.symptoms && measurement.data?.indicator) {
        for (const symptom of measurement?.data?.context?.symptoms) {
          if (measurement.data?.indicator === Indicator.NoResult) {
            result[symptom][Indicator.Quality]! += 1;
          } else {
            const indicator = measurement.data?.indicator;
            if (doesIndicatorExist(indicator)) {
              result[symptom][indicator]! += 1;
            }
          }
        }
      } else {
        const indicator = measurement.data?.indicator;
        if (indicator && doesIndicatorExist(indicator)) {
          result[Symptom.NoSymptoms][indicator]! += 1;
        } else {
          result[Symptom.NoSymptoms][Indicator.Quality]! += 1;
        }
      }
    }
  }
  return result;
};
